// extracted by mini-css-extract-plugin
export default {"cartOrderButton":"CartOrderButton_cartOrderButton__1gNnF"};